import { ActionExecutionResult, IActionBase, IActionsSchema } from '../interfaces/IAction';

export function resolveActions(
  schema: IActionsSchema,
  triggerMap: Record<number, () => ActionExecutionResult>,
): IActionsSchema {
  const hydrate = (actions: IActionBase[] = []): IActionBase[] =>
    actions.map(action =>
      triggerMap[action.id] ? { ...action, execute: triggerMap[action.id] } : action,
    );

  return {
    overTable: hydrate(schema.overTable),
    multipleRecord: hydrate(schema.multipleRecord),
    singleRecord: hydrate(schema.singleRecord),
  };
}
